import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  GqlExamRestoredQuestionKeywordsDocument,
  GqlExamRestoredQuestionsDocument,
  useGqlCreateExamQuestionKeywordMutation,
} from 'generated/graphql'
import { createQuestionKeyword } from '@app.feature/exam/gsat2024-2/schemas/createQuestionKeyword'

export interface CreateQuestionKeywordFormType {
  questionKeyword: string
}

const useCreateQuestionKeywordForm = () => {
  const [createQuestionKeywordMutation] =
    useGqlCreateExamQuestionKeywordMutation({
      refetchQueries: [
        GqlExamRestoredQuestionsDocument,
        GqlExamRestoredQuestionKeywordsDocument,
      ],
    })
  const formMethods = useForm<CreateQuestionKeywordFormType>({
    resolver: yupResolver(createQuestionKeyword),
    mode: 'onChange',
    defaultValues: {
      questionKeyword: '',
    },
  })

  return { formMethods, createQuestionKeywordMutation }
}

export default useCreateQuestionKeywordForm
